import { Box } from '@mui/material'
import React from 'react'
import './style/section2.css'
import { IoMdArrowDropright } from "react-icons/io";

const Section2 = () => {
    return (
        <Box className="mt-10 flex justify-center flex-wrap">
            <Box className='image-box m-7'>
                <img src="https://images.pexels.com/photos/204993/pexels-photo-204993.jpeg?auto=compress&cs=tinysrgb&w=600" alt="" />
            </Box>
            <Box className="m-5 ">
                <span className='color text-sm font-semibold uppercase'>Ring</span>
                <h2 className='font-semibold text-3xl my-5'>Modern and eye-catching lines</h2>
                <p className='text-start text-sm leading-loose text-gray-600 font-medium'>Inspired by the rebellious spirit of America and the intrigue of unwavering authenticity,<br/>
                 R13 launched in Fall 2009. At the forefront of design, R13 cuts avant-garde silhouettes <br/>
                 such as the skinny legging and harem pant from Italian and Turkish denim produced in <br/>
                 Castelfranco, Italy. Pure indigo casting, quality stretch and machine hand mending<br/>
                  give the jeans their superior shape</p>
                <p className='my-5 text-sm font-semibold tracking-widest' >#RINGS #NECKLACES #SILVERRINGS #EARRINGS </p>
                <span className='border-black border-2 py-3 px-6 cursor-pointer hover:bg-black hover:text-white' style={{display:'ruby'}}>Shop Now <IoMdArrowDropright /></span>
            </Box>
        </Box>
    )
}

export default Section2
